import { render } from "./DataImport.vue?vue&type=template&id=33300da9&scoped=true"
import script from "./DataImport.vue?vue&type=script&lang=js"
export * from "./DataImport.vue?vue&type=script&lang=js"

import "./DataImport.vue?vue&type=style&index=0&id=33300da9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33300da9"]])

export default __exports__